export default __webpack_public_path__ + "static/media/unlink-solid.4daa6348.svg";